
export const ENUM_ERROR_USER_REPORT_TYPE = [
    { type: 'illegal_content', title: "محتوای غیرقانونی" },
    { type: 'hate_speech', title: "محتوای توهین آمیز یا نفرت انگیز" },
    { type: 'violence', title: "محتوای خشونت آمیز" },
    { type: 'adult_content', title: "محتوای بزرگسالان" },
    { type: 'misleading_content', title: "محتوای گمراه کننده" },
    { type: 'spam', title: "هرزنامه" },
    { type: 'other', title: "سایر موارد" },
];